const DocumentArrowDown = ({ className }: { className?: string }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    className={className}
  >
    <path
      d="M10 2V6.5C10 7.32843 10.6716 8 11.5 8H16V16.5C16 17.3284 15.3284 18 14.5 18H9.74284C10.5282 17.0491 11 15.8296 11 14.5C11 11.4624 8.53757 9 5.5 9C4.97999 9 4.47683 9.07217 4 9.20703V3.5C4 2.67157 4.67157 2 5.5 2H10ZM11 2.25V6.5C11 6.77614 11.2239 7 11.5 7H15.75L11 2.25ZM5.5 19C7.98528 19 10 16.9853 10 14.5C10 12.0147 7.98528 10 5.5 10C3.01472 10 1 12.0147 1 14.5C1 16.9853 3.01472 19 5.5 19ZM3.14645 14.8536C2.95118 14.6583 2.95118 14.3417 3.14645 14.1464C3.34171 13.9512 3.65829 13.9512 3.85355 14.1464L5 15.2929L5 12.5C5 12.2239 5.22386 12 5.5 12C5.77614 12 6 12.2239 6 12.5V15.2929L7.14645 14.1464C7.34171 13.9512 7.65829 13.9512 7.85355 14.1464C8.04882 14.3417 8.04882 14.6583 7.85355 14.8536L5.85355 16.8536C5.80561 16.9015 5.75036 16.9377 5.69139 16.9621C5.63331 16.9861 5.5697 16.9996 5.503 17L5.5 17L5.497 17C5.4303 16.9996 5.36669 16.9861 5.30861 16.9621C5.25051 16.938 5.19602 16.9026 5.14857 16.8557L5.14605 16.8532L3.14645 14.8536Z"
      fill="currentColor"
    />
  </svg>
);

export default DocumentArrowDown;
